/* bundle-builder.js — Cavie Build Your Planner */
(function () {
  'use strict';

  /* ── Config from section data attributes ─────────────────────── */
  var root = document.getElementById('bundle-builder');
  if (!root) return;

  var CFG = {
    discountPct:  parseFloat(root.dataset.discountPct || 10) / 100,
    discountCode: root.dataset.discountCode || '',
    maxInserts:   parseInt(root.dataset.maxInserts || 4, 10),
  };

  /* ── State ───────────────────────────────────────────────────── */
  var state = {
    step:        1,
    planner:     null,       // { variantId, name, price }
    inserts:     [],
    accessories: [],
  };

  /* ── DOM references ──────────────────────────────────────────── */
  function $id(id) { return document.getElementById(id); }

  var panels     = [1, 2, 3].map(function (n) { return $id('bundle-panel-' + n); });
  var tabs       = [1, 2, 3].map(function (n) { return $id('bundle-tab-' + n); });
  var progs      = [1, 2, 3].map(function (n) { return $id('bundle-prog-' + n); });
  var badges     = [1, 2, 3].map(function (n) { return $id('bundle-badge-' + n); });
  var insertMax  = $id('bundle-insert-max');
  var chipsEl    = $id('bundle-chips');
  var totalEl    = $id('bundle-total');
  var origEl     = $id('bundle-original');
  var savingsEl  = $id('bundle-savings');
  var errorEl    = $id('bundle-error');
  var btnBack    = $id('bundle-btn-back');
  var btnNext    = $id('bundle-btn-next');
  var btnCart    = $id('bundle-btn-cart');

  /* ── Helpers ─────────────────────────────────────────────────── */
  function buildItem(card) {
    return {
      variantId: card.dataset.variantId,
      name:      card.dataset.name,
      price:     parseInt(card.dataset.price, 10), // Shopify prices are in cents
    };
  }

  function allItems() {
    var items = [];
    if (state.planner) items.push(state.planner);
    state.inserts.forEach(function (i) { items.push(i); });
    state.accessories.forEach(function (i) { items.push(i); });
    return items;
  }

  function formatMoney(cents) {
    /* Use Shopify's global if available, otherwise fallback */
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  /* ── Card selection ──────────────────────────────────────────── */
  function selectPlanner(card) {
    /* Deselect previous */
    root.querySelectorAll('[data-group="planner"]').forEach(function (c) {
      c.setAttribute('aria-pressed', 'false');
      var cta = c.querySelector('.bundle-card__cta');
      if (cta) cta.textContent = '+ Add';
    });
    card.setAttribute('aria-pressed', 'true');
    var cta = card.querySelector('.bundle-card__cta');
    if (cta) cta.textContent = '✓ Selected';
    state.planner = buildItem(card);
    updateUI();
  }

  function toggleInsert(card) {
    var id     = card.dataset.variantId;
    var exists = state.inserts.findIndex(function (i) { return i.variantId === id; });

    if (exists >= 0) {
      state.inserts.splice(exists, 1);
      card.setAttribute('aria-pressed', 'false');
      var cta = card.querySelector('.bundle-card__cta');
      if (cta) cta.textContent = '+ Add';
    } else {
      if (state.inserts.length >= CFG.maxInserts) return; // silently block
      state.inserts.push(buildItem(card));
      card.setAttribute('aria-pressed', 'true');
      var cta = card.querySelector('.bundle-card__cta');
      if (cta) cta.textContent = '✓ Added';
    }

    var atMax = state.inserts.length >= CFG.maxInserts;
    insertMax.classList.toggle('is-hidden', !atMax);

    /* Dim unselected cards when at max */
    root.querySelectorAll('[data-group="insert"]').forEach(function (c) {
      var selected = c.getAttribute('aria-pressed') === 'true';
      c.dataset.disabled = (!selected && atMax).toString();
      c.setAttribute('aria-disabled', (!selected && atMax).toString());
    });

    updateUI();
  }

  function toggleAccessory(card) {
    var id     = card.dataset.variantId;
    var exists = state.accessories.findIndex(function (i) { return i.variantId === id; });

    if (exists >= 0) {
      state.accessories.splice(exists, 1);
      card.setAttribute('aria-pressed', 'false');
      var cta = card.querySelector('.bundle-card__cta');
      if (cta) cta.textContent = '+ Add';
    } else {
      state.accessories.push(buildItem(card));
      card.setAttribute('aria-pressed', 'true');
      var cta = card.querySelector('.bundle-card__cta');
      if (cta) cta.textContent = '✓ Added';
    }

    updateUI();
  }

  /* ── Event delegation for all cards ─────────────────────────── */
  root.addEventListener('click', function (e) {
    var card = e.target.closest('.bundle-card');
    if (!card || card.dataset.disabled === 'true') return;
    var group = card.dataset.group;
    if (group === 'planner')   selectPlanner(card);
    else if (group === 'insert')    toggleInsert(card);
    else if (group === 'accessory') toggleAccessory(card);
  });

  root.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    var card = e.target.closest('.bundle-card');
    if (!card || card.dataset.disabled === 'true') return;
    e.preventDefault();
    var group = card.dataset.group;
    if (group === 'planner')        selectPlanner(card);
    else if (group === 'insert')    toggleInsert(card);
    else if (group === 'accessory') toggleAccessory(card);
  });

  /* ── Update footer UI ────────────────────────────────────────── */
  function updateFooter() {
    var all     = allItems();
    var regular = all.reduce(function (sum, i) { return sum + i.price; }, 0);
    var disc    = all.length >= 2 && CFG.discountPct > 0;
    var total   = disc ? Math.round(regular * (1 - CFG.discountPct)) : regular;
    var saving  = regular - total;

    /* Chips */
    if (all.length === 0) {
      chipsEl.innerHTML = '<span class="bundle-footer__empty">Nothing selected yet</span>';
    } else {
      chipsEl.innerHTML = all.map(function (i) {
        return '<span class="bundle-chip">' + esc(i.name) + '</span>';
      }).join('');
    }

    /* Price */
    totalEl.textContent = formatMoney(total);

    if (disc) {
      origEl.textContent = formatMoney(regular);
      origEl.classList.remove('is-hidden');
      savingsEl.textContent = 'You save ' + formatMoney(saving) + ' — ' + Math.round(CFG.discountPct * 100) + '% bundle discount';
      savingsEl.classList.remove('is-hidden');
    } else {
      origEl.classList.add('is-hidden');
      savingsEl.classList.add('is-hidden');
    }
  }

  /* ── Update progress bars + badges ──────────────────────────── */
  function updateProgress() {
    var pcts = [
      state.planner ? 100 : 0,
      Math.min((state.inserts.length / CFG.maxInserts) * 100, 100),
      Math.min((state.accessories.length / 3) * 100, 100),
    ];

    progs.forEach(function (el, i) {
      if (el) el.style.width = pcts[i] + '%';
    });

    var counts = [
      state.planner ? '1 selected' : '',
      state.inserts.length > 0 ? state.inserts.length + ' selected' : '',
      state.accessories.length > 0 ? state.accessories.length + ' selected' : '',
    ];

    badges.forEach(function (el, i) {
      if (!el) return;
      var txt = counts[i];
      el.textContent = txt;
      el.classList.toggle('is-hidden', !txt);
    });
  }

  /* ── Update next button disabled state ──────────────────────── */
  function canAdvance() {
    if (state.step === 1) return !!state.planner;
    if (state.step === 2) return state.inserts.length > 0;
    return true; // step 3 — accessories are optional
  }

  function updateButtons() {
    var ok = canAdvance();
    btnNext.disabled = !ok;
    btnNext.setAttribute('aria-disabled', ok ? 'false' : 'true');
  }

  /* ── Master updateUI ─────────────────────────────────────────── */
  function updateUI() {
    updateFooter();
    updateProgress();
    updateButtons();
    hideError();
  }

  /* ── Navigation ──────────────────────────────────────────────── */
  function goToStep(n) {
    state.step = n;

    panels.forEach(function (panel, i) {
      panel.classList.toggle('is-hidden', i + 1 !== n);
    });

    tabs.forEach(function (tab, i) {
      var active = i + 1 === n;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    /* Show/hide Back */
    btnBack.classList.toggle('is-hidden', n === 1);

    /* Show Next vs Cart */
    if (n === 3) {
      btnNext.classList.add('is-hidden');
      btnCart.classList.remove('is-hidden');
    } else {
      btnNext.classList.remove('is-hidden');
      btnCart.classList.add('is-hidden');
    }

    updateUI();

    /* Scroll section into view */
    window.scrollTo({
      top: root.getBoundingClientRect().top + window.scrollY - 20,
      behavior: 'smooth',
    });
  }

  /* Tab clicks — free navigation */
  tabs.forEach(function (tab) {
    if (!tab) return;
    tab.addEventListener('click', function () {
      goToStep(parseInt(tab.dataset.step, 10));
    });
  });

  btnNext.addEventListener('click', function () {
    if (!canAdvance()) {
      showError('Please make a selection to continue.');
      return;
    }
    goToStep(state.step + 1);
  });

  btnBack.addEventListener('click', function () {
    goToStep(state.step - 1);
  });

  /* ── Add to cart ─────────────────────────────────────────────── */
  btnCart.addEventListener('click', function () {
    if (!state.planner) {
      showError('Please select a binder to continue.');
      return;
    }

    btnCart.disabled    = true;
    btnCart.textContent = 'Adding to cart…';

    var items = allItems().map(function (i) {
      return { id: parseInt(i.variantId, 10), quantity: 1 };
    });

    fetch('/cart/add.js', {
      method:  'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept':       'application/json',
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart.');
          });
        }
        return res.json();
      })
      .then(function () {
        /* Notify theme cart drawer if it exists */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('theme:cart:open'));

        /* Redirect with discount code pre-applied */
        if (CFG.discountCode) {
          window.location.href = '/checkout?discount=' + encodeURIComponent(CFG.discountCode);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        showError(err.message || 'Something went wrong. Please try again.');
        btnCart.disabled    = false;
        btnCart.textContent = 'Add bundle to cart →';
      });
  });

  /* ── Error helpers ───────────────────────────────────────────── */
  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.classList.remove('is-hidden');
  }

  function hideError() {
    errorEl.classList.add('is-hidden');
  }

  /* ── Init ────────────────────────────────────────────────────── */
  /* Ensure step 2 & 3 panels are hidden, step 1 visible */
  goToStep(1);

  /* Initialise footer with zero state */
  updateUI();

})();
